<script setup>
import Layout from "../Layouts/Customer.vue";
import Button from "primevue/button";
import MultiSelect from "primevue/multiselect";
import Dialog from "primevue/dialog";
import Dropdown from "primevue/dropdown";
import {useForm, Link} from "@inertiajs/inertia-vue3";
import { ref } from "vue";
import Card from "primevue/card";
import Tag from "primevue/tag";
import { useToast } from "primevue/usetoast";
import { useConfirm } from "primevue/useconfirm";
import {useVuelidate} from "@vuelidate/core";
import {required$} from "../utils/validators";
import {scrollToFirstError} from "../utils/form";
import DeviceReasonsOP from "../Components/DeviceReasonsOP.vue";
import SimplybookIcon from "../Components/SimplybookIcon.vue";


const props = defineProps([
    'customer',
    'menuItems',
    'flash',
    'devices',
    'deviceReasonsMap',
]);
const deviceReasonsOP = ref(null)

const togglePopOver = (e, device) => {
    deviceReasonsOP.value.togglePopOver(e, device)
}
</script>

<template>
    <Layout :customer="customer" :menu-items="menuItems" :flash="flash">
        <div class="text-sm py-7">
            <div class="px-14 mb-7">
                <h1 class="text-black text-2xl font-regular">
                    Geräten
                </h1>
            </div>

            <div class="grid grid-cols-[56px_1fr_1fr_1fr_1fr_56px] gap-0 items-center">
                <div class="bg-[#EEEBE4] h-full">
                    &nbsp;
                </div>

                <div class="bg-[#EEEBE4] h-full">
                    &nbsp;
                </div>

                <div class="bg-[#EEEBE4] h-full">
                    <div class="py-3">
                        <h4 class="text-black text-xs font-extralight">Gerät</h4>
                    </div>
                </div>

                <div class="bg-[#EEEBE4] h-full">
                    &nbsp;
                </div>

                <div class="bg-[#EEEBE4] h-full">
                    &nbsp;
                </div>

                <div class="bg-[#EEEBE4] h-full">
                </div>

                <template v-for="item in devices">
                    <div class="border-b border-[#C5C6CC] h-full">
                    </div>

                    <div class="border-b border-[#C5C6CC] h-full">
                    </div>

                    <div class="border-b border-[#C5C6CC] h-full">
                        <div class="py-3">
                            {{ item.name }}
                        </div>
                    </div>

                    <div class="border-b border-[#C5C6CC] h-full">
                        <div class="py-3 flex items-center justify-end h-full">
                            <!-- SimplyBook Bookings Link -->
                            <Link 
                                :href="`/customers/${customer.uuid}/simplybook-bookings/${item.uuid}`"
                                class="text-blue-600 hover:text-blue-700 p-1 mr-3"
                                title="SimplyBook Buchungen anzeigen"
                            >
                                <SimplybookIcon :size="14" />
                            </Link>
                            
                            <div
                                v-if="item.pivot?.warning_type"
                                class="flex gap-3"
                                @mouseenter="togglePopOver($event, item)">
                                <span class="text-xs font-extralight">Freigabe durch VIGORY nötig</span>

                                <i
                                    class="pi pi-exclamation-circle"
                                    :class="{
                                            'text-[#FF0000]': item.pivot?.warning_type == 'no',
                                            'text-[#FFC000]': item.pivot?.warning_type == 'maybe'
                                    }"></i>
                            </div>

                            <i v-else class="pi pi-check-circle" style="color: green"></i>
                        </div>
                    </div>

                    <div class="border-b border-[#C5C6CC] h-full">
                    </div>

                    <div class="border-b border-[#C5C6CC] h-full">
                    </div>
                </template>
            </div>
        </div>

        <DeviceReasonsOP ref="deviceReasonsOP"
                         :device-reasons-map="deviceReasonsMap"></DeviceReasonsOP>
    </Layout>
</template>
